import mobileAdjustment from "../GeneralMobileAdjustments";
class MobileBulletTextControlView {

    constructor() {}

    afterRender(control) { 
        let element = mobileAdjustment.adjustMobileControl(control);
        element.css({"height":"auto","text-align": "left"});
        element.find("li").css("white-space", "pre-wrap");
    }
}

const mobileBulletTextControlView = new MobileBulletTextControlView();
export default mobileBulletTextControlView;